import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { USER_PREFERENCE_API } from "../apiRoutes";

interface UseGetUserPreferenceByUserIdProps {
  userId: string;
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserPreferenceByUserId = async (userId: string, communityId: string) =>
  await axiosAuth.get(`${USER_PREFERENCE_API}/community/${communityId}/user/${userId}`);

const useGetUserPreferenceByUserId = ({
  userId,
  communityId,
  queryParams,
}: UseGetUserPreferenceByUserIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user-preference", userId, communityId],
    queryFn: () => getUserPreferenceByUserId(userId, communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!userId && !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetUserPreferenceByUserId;
